

document.addEventListener("DOMContentLoaded", function () {



/////////// JS for size selctor in product details page 
document.addEventListener('change', function (event) {
  if (!event.target.matches('input[type="radio"][id^="swatch-"]')) return;
  if (!event.target.checked) return;

  var value = event.target.value;
  var liveRegion = document.getElementById('swatch-live-announcement');

  if (!liveRegion) {
    liveRegion = document.createElement('div');
    liveRegion.id = 'swatch-live-announcement';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.className = 'visually-hidden';
    document.body.appendChild(liveRegion);
  }

  liveRegion.textContent = 'Selected: ' + value;
});





  // ---------- FAQ Accordion ----------
  // NOTE: original code only ever removed "active" on click, so the
  // accordion could never open through this handler. Changed to toggle.
  document
    .querySelectorAll(".faqAccordion > dt > button")
    .forEach(function (button) {
      button.addEventListener("click", function () {
        button.classList.toggle("active");
      });
    });

  // ---------- Back to top button ----------
 
  var backToTopButton = document.getElementById("back-to-top");
  if (backToTopButton) {
    window.addEventListener("scroll", function () {
      if (window.pageYOffset > 300) {
        backToTopButton.style.display = "block";
      } else {
        backToTopButton.style.display = "none";
      }
    });

    backToTopButton.addEventListener("click", function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
      window.setTimeout(function () {
        var skipTarget = document.getElementById("backtoheader");
        if (skipTarget) {
          skipTarget.focus();
        }
      }, 600);
    });
  }

  // ---------- Link accessibility labels (tel / mailto / external) ----------
  document.querySelectorAll("a[href]").forEach(function (link) {
    var href = link.getAttribute("href");
    if (!href) return;

    // Telephone links
    if (href.startsWith("tel:")) {
      var phoneNumber = href.replace("tel:", "").trim();
      link.setAttribute("aria-label", "Call us " + phoneNumber);
      return;
    }

    // Email links
    if (href.startsWith("mailto:")) {
      var email = href.replace("mailto:", "").split("?")[0].trim();
      link.setAttribute("aria-label", "Email " + email);
      return;
    }

    // External links
    try {
      var url = new URL(link.href, window.location.origin);

      if (url.hostname !== window.location.hostname) {
        var ariaLabel = link.getAttribute("aria-label");
        var linkText = link.textContent.trim();
        var title = link.getAttribute("title");
        var accessibleName = ariaLabel || title || linkText || "External link";

        var warning =
          link.target === "_blank"
            ? " - Redirecting to a third-party website (opens in a new tab)"
            : " - Redirecting to a third-party website";

        if (!accessibleName.includes("Redirecting to a third-party website")) {
          link.setAttribute("aria-label", accessibleName + warning);
        }
      }
    } catch (e) {}
  });

  // ---------- Shougan slider nav buttons ----------
  document.querySelectorAll(".shg-sld-nav-button").forEach(function (button) {
    button.setAttribute("role", "button");
    button.setAttribute("tabindex", "0");
    button.setAttribute(
      "aria-label",
      button.classList.contains("shg-sld-left")
        ? "Previous slide"
        : "Next slide",
    );
  });

  // ---------- Decorative images on Shougan homepage ----------
  document
    .querySelectorAll(".shg-image-content-wrapper img")
    .forEach(function (img) {
      img.setAttribute("aria-hidden", "true");
    });

  // ---------- Unique IDs for empty Shougan overlay divs ----------
  document
    .querySelectorAll("div.shg-box-overlay")
    .forEach(function (element, index) {
      if (
        !element.id &&
        element.children.length === 0 &&
        element.textContent.trim() === ""
      ) {
        element.id = "shg-box-overlay-" + (index + 1);
      }
    });

  // ---------- Mega menu dialog roles ----------
  document.querySelectorAll(".dropdown_container").forEach(function (dropdown) {
    dropdown.setAttribute("role", "dialog");
    dropdown.setAttribute("aria-modal", "true");
  });

  // ---------- Mega menu / mobile menu focus management ----------
  var lastFocusedButton;

  document.querySelectorAll(".mobile_nav").forEach(function (button) {
    button.addEventListener("click", function () {
      lastFocusedButton = this;

      setTimeout(function () {
        var dropdown = document.querySelector(
          ".dropdown_container[data-dropdown='menu']",
        );
        if (dropdown) {
          dropdown.setAttribute("tabindex", "0");
          dropdown.focus();
        }
      }, 1000);
    });
  });

  document.querySelectorAll(".close_btn").forEach(function (button) {
    button.addEventListener("click", function () {
      setTimeout(function () {
        if (lastFocusedButton) {
          lastFocusedButton.setAttribute("tabindex", "0");
          lastFocusedButton.focus();
        }
      }, 1000);
    });
  });

  // ---------- Links that wrap an image ----------
  document.querySelectorAll(".shogun-image-link").forEach(function (link) {
    var image = link.querySelector("img");
    if (image && !link.hasAttribute("aria-label")) {
      var altText = image.getAttribute("alt");
      if (altText) {
        link.setAttribute("aria-label", altText);
      }
    }
  });

  // ---------- Remove empty headings ----------
  document
    .querySelectorAll("h1, h2, h3, h4, h5, h6")
    .forEach(function (heading) {
      if (!heading.textContent.trim()) {
        heading.remove();
      }
    });

  // ---------- Hide empty Shougan product titles ----------
  function hideEmptyTitles() {
    document
      .querySelectorAll(".shg-product-title-component")
      .forEach(function (el) {
        var title = el.querySelector(
          '[data-shg-product-target="product-title"]',
        );
        if (title && !title.textContent.trim()) {
          el.style.display = "none";
        }
      });
  }
  hideEmptyTitles();
  new MutationObserver(hideEmptyTitles).observe(document.body, {
    childList: true,
    subtree: true,
  });

  // ---------- "Regular price" visually-hidden label ----------
  document.querySelectorAll(".shg-product-price").forEach(function (price) {
    if (
      !price.previousElementSibling ||
      !price.previousElementSibling.classList.contains("visually-hidden")
    ) {
      var hiddenText = document.createElement("span");
      hiddenText.className = "visually-hidden";
      hiddenText.textContent = "Regular price ";
      price.parentNode.insertBefore(hiddenText, price);
    }
  });

  // ---------- Sidebar filter toggle aria-expanded ----------
  document
    .querySelectorAll(".sidebar-block .sidebar__collection-filter h2.toggle")
    .forEach(function (button) {
      function updateAriaExpanded() {
        button.setAttribute(
          "aria-expanded",
          button.classList.contains("active") ? "true" : "false",
        );
      }
      updateAriaExpanded();
      button.addEventListener("click", function () {
        setTimeout(updateAriaExpanded, 100);
      });
    });

  // ---------- Announcement bar close button focus ----------
  var announcementClose = document.getElementById("qab_close");
  if (announcementClose) {
    announcementClose.addEventListener("click", function () {
      setTimeout(function () {
        var skipRegion = document.getElementById("backtoheader");
        if (skipRegion) {
          skipRegion.focus();
        }
      }, 500);
    });
  }

  // contact us dashes in numbers
  document.querySelectorAll('a[href^="tel:"]').forEach(function (link) {
    var href = link.getAttribute("href");

    if (href && href.includes("-")) {
      link.setAttribute("href", href.replace(/-/g, ""));
    }
  });
});

///,//////////////////////////////////////////////////////////////////////

document.querySelectorAll('.tabs a[role="tab"]').forEach(function (tab) {
  tab.addEventListener("click", function (e) {
    e.preventDefault();

    var target = document.querySelector(this.getAttribute("href"));

    if (!target) return;

    document.querySelectorAll('.tabs a[role="tab"]').forEach(function (t) {
      var isActive = t === tab;

      t.setAttribute("aria-selected", isActive ? "true" : "false");

      t.setAttribute("tabindex", isActive ? "0" : "-1");
    });

    document
      .querySelectorAll('.tabs-content [role="tabpanel"]')
      .forEach(function (panel) {
        panel.hidden = panel !== target;
      });

    // Move focus to selected tab
    tab.focus();
  });

  //
  // Shougon Shop- Now button With title
});

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".shg-btn-wrapper .shg-btn")
    .forEach(function (button) {
      var buttonText = button.textContent.trim();

      // Find nearest heading inside same Shogun section
      var section = button.closest(".shg-box-content");
      var heading = section
        ? section.querySelector("h1, h2, h3, h4, h5, h6")
        : null;

      var headingText = heading ? heading.textContent.trim() : "";

      if (buttonText && headingText) {
        button.setAttribute("aria-label", buttonText + " " + headingText);
      }
    });

  //////////////// JS FOR REGULA PRICE SPAN
 function addRegularPriceLabel() {
  document.querySelectorAll(".current_price, .single_price").forEach(function (price) {
    if (!price.querySelector(".visually-hidden")) {
      var span = document.createElement("span");
      span.className = "visually-hidden";
      span.textContent = "Regular price ";
      price.prepend(span);
    }
  });
} 

addRegularPriceLabel();

new MutationObserver(addRegularPriceLabel).observe(document.body, {
  childList: true,
  subtree: true
});

  document.querySelectorAll(".shg-hr-wrapper hr").forEach(function (hr) {
    hr.setAttribute("aria-hidden", "true");
  });
});
